import {
  type AutocompleteConfigurableFilter,
  type CheckboxConfigurableFilter,
  type ConfigurableFilter,
  FILTER_TYPES,
  type MultiOptionWithRadioConfigurableFilter,
  type MultiOptionWithRangeConfigurableFilter,
  type RadioConfigurableFilter,
} from '../types.ts';

export function isRadioFilter<Criteria>(
  filter: ConfigurableFilter<keyof Criteria>
): filter is RadioConfigurableFilter<keyof Criteria> {
  return filter.type === FILTER_TYPES.RADIO;
}

export function isCheckboxFilter<Criteria>(
  filter: ConfigurableFilter<keyof Criteria>
): filter is CheckboxConfigurableFilter<keyof Criteria> {
  return filter.type === FILTER_TYPES.CHECKBOX;
}

export function isAutocompleteFilter<Criteria>(
  filter: ConfigurableFilter<keyof Criteria>
): filter is AutocompleteConfigurableFilter<keyof Criteria> {
  return filter.type === FILTER_TYPES.AUTOCOMPLETE;
}

export const isMultiOptionWithRadioFilter = <Criteria>(
  filter: ConfigurableFilter<keyof Criteria>
): filter is MultiOptionWithRadioConfigurableFilter<keyof Criteria> => {
  return filter.type === FILTER_TYPES.MULTI_OPTION_WITH_RADIO;
};

export const isMultiOptionWithRangeFilter = <Criteria>(
  filter: ConfigurableFilter<keyof Criteria>
): filter is MultiOptionWithRangeConfigurableFilter<keyof Criteria> => {
  return filter.type === FILTER_TYPES.MULTI_OPTION_WITH_RANGE;
};

export function isFilterWithOptions<Criteria>(
  filter: ConfigurableFilter<keyof Criteria>
): filter is
  | CheckboxConfigurableFilter<keyof Criteria>
  | RadioConfigurableFilter<keyof Criteria>
  | AutocompleteConfigurableFilter<keyof Criteria>
  | MultiOptionWithRadioConfigurableFilter<keyof Criteria>
  | MultiOptionWithRangeConfigurableFilter<keyof Criteria> {
  return (
    isCheckboxFilter<Criteria>(filter) ||
    isRadioFilter<Criteria>(filter) ||
    isAutocompleteFilter<Criteria>(filter) ||
    isMultiOptionWithRadioFilter<Criteria>(filter) ||
    isMultiOptionWithRangeFilter<Criteria>(filter)
  );
}
